/* ---------------------------------------------------------------------------
   No 7 — Google Maps erst nach Cookie-Einwilligung laden
   ---------------------------------------------------------------------------
   Warum im Theme und nicht in der Pandectes-App:
   `assets/component-interactive-map.js` (KrownThemes) haengt das Maps-Skript
   dynamisch per document.createElement('script') an <body> an. Ein Blocker,
   der nur ausgelieferte <script>-Tags im HTML umschreibt, kann das nicht
   sehen. Deshalb wird hier das Einfuegen selbst abgefangen — das wirkt
   unabhaengig davon, in welcher Reihenfolge die Theme-Skripte laufen.

   Verhalten:
   - ohne Einwilligung: das Maps-Skript wird nicht eingefuegt, an der Stelle
     der Karte steht ein Hinweis mit Knopf zu den Cookie-Einstellungen;
   - sobald die Einwilligung vorliegt (Pandectes-Event oder Cookie): das
     zurueckgehaltene Skript wird nachgeladen, die Karte baut sich auf, ohne
     dass die Seite neu geladen werden muss;
   - ist Pandectes gar nicht vorhanden (App deinstalliert), bleibt die Karte
     gesperrt, kann aber vom Besucher per Knopf bewusst geladen werden.

   Muss VOR allen Theme-Skripten laufen -> in layout/theme.liquid im <head>
   ohne defer eingebunden.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MAPS_HOST = 'maps.googleapis.com';
  var COOKIE = '_pandectes_gdpr';

  var zurueckgehalten = [];
  var freigegeben = false;

  /* --- Einwilligung lesen ------------------------------------------------ */

  // Es koennen mehrere Cookies gleichen Namens existieren (unterschiedliche
  // Pfade/Domains). Dann zaehlt die juengste Entscheidung, nicht die erste,
  // die der Browser zufaellig zuerst mitschickt.
  function cookieDaten() {
    var treffer = document.cookie
      .split(';')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.indexOf(COOKIE + '=') === 0; })
      .map(function (roh) {
        try {
          return JSON.parse(atob(decodeURIComponent(roh.split('=').slice(1).join('='))));
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean);

    if (!treffer.length) return null;
    treffer.sort(function (a, b) { return (b.timestamp || 0) - (a.timestamp || 0); });
    return treffer[0];
  }

  // Bewusst streng: geladen wird nur bei einem eindeutigen Ja. Alles andere
  // (kein Cookie, "deny", unklarer Zustand) gilt als "nicht eingewilligt".
  function eingewilligt() {
    var P = window.Pandectes;
    if (P && P.consent && P.consent.functionality === true) return true;

    var c = cookieDaten();
    if (!c) return false;
    if (c.status === 'allow') return true;
    // Teilzustimmung: Bit 1 = Funktionalitaet (Pandectes-Kategorien 1/2/4/8)
    if (typeof c.preferences === 'number' && (c.preferences & 1) === 1) return true;
    return false;
  }

  /* --- Skript-Einfuegen abfangen ----------------------------------------- */

  function istMapsSkript(node) {
    return node &&
      node.tagName === 'SCRIPT' &&
      typeof node.src === 'string' &&
      node.src.indexOf(MAPS_HOST) !== -1;
  }

  function abfangen(original) {
    return function (node) {
      if (!freigegeben && istMapsSkript(node)) {
        zurueckgehalten.push({ src: node.src, onload: node.onload, ziel: this });
        hinweisZeigen();
        return node; // so tun, als waere es eingefuegt
      }
      return original.apply(this, arguments);
    };
  }

  var appendChildOriginal = Node.prototype.appendChild;
  var insertBeforeOriginal = Node.prototype.insertBefore;
  Node.prototype.appendChild = abfangen(appendChildOriginal);
  Node.prototype.insertBefore = function (node, ref) {
    if (!freigegeben && istMapsSkript(node)) {
      zurueckgehalten.push({ src: node.src, onload: node.onload, ziel: this });
      hinweisZeigen();
      return node;
    }
    return insertBeforeOriginal.apply(this, arguments);
  };

  /* --- Hinweis an der Stelle der Karte ----------------------------------- */

  // Styles bewusst hier und nicht in theme.css: dann liegt die komplette
  // Anpassung in einer einzigen No7-Datei und geht beim naechsten
  // Theme-Update nicht verloren.
  function styleEinfuegen() {
    if (document.getElementById('no7-map-consent-style')) return;
    var s = document.createElement('style');
    s.id = 'no7-map-consent-style';
    s.textContent =
      '.no7-map-consent{display:flex;flex-direction:column;align-items:center;' +
      'justify-content:center;gap:1rem;height:100%;min-height:14rem;padding:2rem;' +
      'text-align:center;background:rgba(56,50,42,.06);border-radius:inherit;}' +
      '.no7-map-consent__text{margin:0;max-width:30rem;}';
    document.head.appendChild(s);
  }

  function hinweisZeigen() {
    styleEinfuegen();
    var ziele = document.querySelectorAll('[data-js-map-object]');
    for (var i = 0; i < ziele.length; i++) {
      var el = ziele[i];
      if (el.querySelector('.no7-map-consent')) continue;

      var box = document.createElement('div');
      box.className = 'no7-map-consent';
      box.innerHTML =
        '<p class="no7-map-consent__text">Die Karte wird von Google Maps geladen. ' +
        'Dabei werden Daten an Google &uuml;bertragen. Wir zeigen sie erst nach ' +
        'Ihrer Einwilligung.</p>';

      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'button button--outline button--regular no7-map-consent__btn';

      if (window.Pandectes && window.Pandectes.fn && window.Pandectes.fn.openPreferences) {
        knopf.textContent = 'Cookie-Einstellungen öffnen';
        knopf.addEventListener('click', function () {
          window.Pandectes.fn.openPreferences();
        });
      } else {
        // Fallback ohne Consent-App: bewusste Einzelfreigabe durch den Besucher
        knopf.textContent = 'Karte laden';
        knopf.addEventListener('click', function () { freigeben(); });
      }

      box.appendChild(knopf);
      el.appendChild(box);
    }
  }

  function hinweisEntfernen() {
    var alte = document.querySelectorAll('.no7-map-consent');
    for (var i = 0; i < alte.length; i++) {
      alte[i].parentNode.removeChild(alte[i]);
    }
  }

  /* --- Freigabe ----------------------------------------------------------- */

  function freigeben() {
    if (freigegeben) return;
    freigegeben = true;
    Node.prototype.appendChild = appendChildOriginal;
    Node.prototype.insertBefore = insertBeforeOriginal;
    hinweisEntfernen();

    while (zurueckgehalten.length) {
      var eintrag = zurueckgehalten.shift();
      var s = document.createElement('script');
      s.async = true;
      if (eintrag.onload) s.onload = eintrag.onload;
      s.src = eintrag.src;
      document.body.appendChild(s);
    }
  }

  function pruefen() {
    if (!freigegeben && eingewilligt()) freigeben();
  }

  /* --- Auf Einwilligung reagieren ---------------------------------------- */

  ['PandectesEvent_OnConsent', 'PandectesEvent_OnInitialize', 'PandectesEvent_OnClose']
    .forEach(function (name) {
      document.addEventListener(name, pruefen);
      window.addEventListener(name, pruefen);
    });

  document.addEventListener('DOMContentLoaded', pruefen);
  pruefen();
})();
